module.exports = __webpack_public_path__ + "static/img/ljgd.dd909e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/ljgd.png
// module id = mAF4
// module chunks = 171